import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import ResolvePopup from 'components/ResolvePopup';
import {
  BUYERS_ACTIVITY_TRACK_TYPE,
  BuyersActivityTrackType,
} from 'models/Lead';
import {
  EVENT_TYPES,
  EVENT_TYPE_TITLE_COPY,
  EVENT_TYPE_TOOLTIP_COPY,
} from './data';

import './EventTypeFilters.styles.scss';

type EventTypeFiltersProps = {
  className?: string;
  selectedEventTypes: BuyersActivityTrackType[];
  dataRoomDisabled?: boolean;
  eventTypes?: BuyersActivityTrackType[];
  onChange: (type: BuyersActivityTrackType, checked: boolean) => void;
};

const EventTypeFilters: React.FC<EventTypeFiltersProps> = (props) => {
  const {
    className,
    selectedEventTypes,
    dataRoomDisabled,
    eventTypes = EVENT_TYPES,
    onChange,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('event-type-filters', className);

  return (
    <div className={classes}>
      {eventTypes.map((type) => {
        const selected = selectedEventTypes.includes(type);
        const isDisabled =
          dataRoomDisabled && type === BUYERS_ACTIVITY_TRACK_TYPE.DATA_ROOM;

        return (
          <ResolvePopup
            key={type}
            onHover
            popupContent={
              isDisabled
                ? t('noDataRoomAccessTooltip')
                : t(EVENT_TYPE_TOOLTIP_COPY[type])
            }
          >
            <Button
              disabled={isDisabled}
              className={classNames({ selected })}
              onClick={() => onChange(type, !selected)}
            >
              {t(EVENT_TYPE_TITLE_COPY[type])}
            </Button>
          </ResolvePopup>
        );
      })}
    </div>
  );
};

export default EventTypeFilters;
